var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "likert-scale-wrapper" },
    [
      _c(
        "el-collapse",
        {
          attrs: { accordion: true },
          model: {
            value: _vm.active,
            callback: function($$v) {
              _vm.active = $$v
            },
            expression: "active"
          }
        },
        [
          _c(
            "el-collapse-item",
            { attrs: { title: "Likert Scale Guide", name: "guide" } },
            [
              _c("p", [
                _vm._v(
                  "In this performance review, you’ll answer questions using a 1 to 5 scale, where 1 means the lowest or worst rating, and 5 means the highest or best rating. Each question will ask you to rate specific areas of job performance, like teamwork, communication, or job skills. This helps us consistently measure strengths and identify areas where you might want to grow or get more support"
                )
              ]),
              _c(
                "div",
                { staticClass: "likert-container flex" },
                _vm._l(_vm.guideData, function(data) {
                  return _c(
                    "div",
                    {
                      key: data.id,
                      staticClass: "likert-box flex flex-column"
                    },
                    [
                      _c("div", { staticClass: "number" }, [
                        _vm._v(_vm._s(data.id))
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(data.title))
                        ]),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(_vm._s(data.description))
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }